module.exports = __webpack_public_path__ + "static/media/logo-horizontal-white.9e22f124.svg";